export default __webpack_public_path__ + "static/media/security_incident_management_e_discovery_and_cloud_forensics.5b6976ea.png";